import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, FormArray, Validators } from "@angular/forms";
import { MenuComponent } from "../menu/menu.component";

@Component({
  selector: 'app-huespedes',
  templateUrl: './huespedes.component.html',
  styleUrls: ['./huespedes.component.scss']
})
export class HuespedesComponent implements OnInit {
  @Input() mobileMode: boolean;
  @Input() airLines: any = false;
  @Input() class: String = 'py-3';
  @Input() height: String = '56px';
  @Output() formUpdate: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(MenuComponent) menu: MenuComponent;
  @Input() maxHabitacion: any = 8;
  @Input() maxADT: any = 8;
  @Input() maxCHD: any = 6;
  @Input() maxHuespedes:any = 16;
  @Input() adultos:any = 2;
  @Input() ninos:any = 0;
  // public huespedes: any = 0;
  public form: FormGroup;
  public habitCount: number;
  public totalAdultos: any = 0;
  public edadesPermision: any = [];
  constructor(private fb: FormBuilder) {
    
  }
  initEdadesPermision(max: number) {
    for (let index = 0; index < max; index++) {
      this.edadesPermision.push({
        value: index,
        label: (index === 0) ? '<1' : index
      });
    }
  }

  ngOnInit() {
    console.log("Adultos input: ", this.adultos)
    this.habitCount = 1;
    this.initEdadesPermision(17);
    this.form = this.fb.group({
      fHab: this.fb.array([
        this.initX(this.adultos)
      ])
    });

    this.form.valueChanges.subscribe((data: any) => {
      console.log('Algo ha cambiado en form:', data);
      this.totalAdultos = data.fHab.reduce((a, b) => a + (b.fAdults + b.fChilds), 0);
      this.updateFlightHotel();
    }, (err) => {
      console.error('Error :', err);
    });

    this.updateFlightHotel();
    this.totalAdultos = this.form.controls.fHab.value.reduce((a, b) => a + (b.fAdults + b.fChilds), 0);
  }
  /****************** Trabajando con array ***********************/
  get fHabitArr(): FormArray {
    return this.form.get('fHab') as FormArray;
  }
  initX(adults: number = 1) {
    console.log("Adultos a insertar: ", adults);
    
    return this.fb.group({
      fAdults: [adults, []],
      fChilds: [0, []],
      'fEdades': this.fb.array([])
    });
  }
  addX() {
    const control = <FormArray>this.form.controls['fHab'];
    control.push(this.initX());
  }

  deleteX(idx: number) {
    const control = <FormArray>this.form.controls['fHab'];
    control.removeAt(idx);
  }

  initY(edad: any = '') {
    return this.fb.group({
      'fEdad': [edad, [Validators.required]],
    });
  }
  addY(ix) {
    const control = (<FormArray>this.form.controls['fHab']).at(ix).get('fEdades') as FormArray;
    control.push(this.initY());
  }
  deletey(ix, idy: number) {
    const control = (<FormArray>this.form.controls['fHab']).at(ix).get('fEdades') as FormArray;
    control.removeAt(idy);
  }
  /************************************************************************ */
  addBed() {
    if (this.habitCount >= this.maxHabitacion) { return; }
    this.habitCount++;
    this.addX();
  }

  removeLastBed() {
    if (this.form.get('fHab').value.length > 1) {
      this.habitCount--;
      this.deleteX(this.form.get('fHab').value.length - 1)
    }
  }

  updHues(index: number, huesped: string, operation: string) {
    const item = this.fHabitArr.controls[index];
    const huespedes = item.value[huesped];
    const newH = (operation === 'add') ? huespedes + 1 : huespedes - 1;
    let totalH = item.value['fChilds'] + item.value['fAdults'] + ((operation === 'add') ? 0 : - 1);
    // console.log("Huesperdes: ", huespedes, this.maxHuespedes, totalH, (totalH > this.maxHuespedes));
    
    if ((totalH >= this.maxHuespedes) || (huesped === 'fAdults' && (newH > this.maxADT || newH < 1)) || (huesped === 'fChilds' && (newH > this.maxCHD || newH < 0))) {
      return;
    }
    if (huesped === 'fAdults') {
      item.patchValue({ fAdults: newH });
    } else if (huesped === 'fChilds') {
      if (operation === 'add') {
        this.addY(index);
      } else if (operation === 'sub') {
        this.deletey(index, 0);
      }
      item.patchValue({ fChilds: newH });
    }
  }

  updateFlightHotel() {
    //Actualiza Output
    this.formUpdate.emit(this.form.value);
  }
}
